exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "/* purgecss start ignore */\nsvg path[data-v-5f9d9010] {\n  stroke: var(--highlight-color);\n}\n\n/* purgecss end ignore */\n", ""]);
